export enum StatusDropdownLayoutType {
  Legacy = 'legacy',
  Modern = 'modern',
}
